import React from 'react';
import { useSelector } from 'react-redux';
import { ICONS } from '../../constants/imageConstants';

const StatusIndicator = ({ className = '' }) => {
  const { isOnline } = useSelector(state => state.ui.networkStatus);
  const { syncInProgress, pendingCount } = useSelector(state => state.sync);

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="relative">
        <img 
          src={isOnline ? ICONS.ONLINE : ICONS.OFFLINE} 
          width={16} 
          height={11} 
          alt={isOnline ? 'Online' : 'Offline'} 
        />
        {syncInProgress && (
          <div className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-blue-600 rounded-full animate-pulse" />
        )}
      </div>
      <div className="flex flex-col items-start">
        <span className={`text-sm font-semibold ${isOnline ? 'text-green-600' : 'text-red-600'}`}>
          {syncInProgress ? 'Syncing...' : (isOnline ? 'Online' : 'Offline')}
        </span>
        {!isOnline && pendingCount > 0 && (
          <span className="text-xs text-yellow-600 font-medium">{pendingCount} pending</span>
        )}
      </div>
    </div>
  );
};

export default StatusIndicator;